import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import NavBar from '../components/NavBar'

class HomePage extends React.Component {
  render() {
    return (
      <div className="container"> 
        <NavBar activeKey="home" />
        <Row className="mb-4"/>
        <Row>
          <Col xs={12} md={6} lg={3}>
            <Card>
              <Card.Img variant="top" src="./files/headshot_square.jpg" alt="Headshot of Xanda Schofield"/>
              <Card.Body>
                <Card.Title><b>Xanda Schofield</b></Card.Title>
                <Card.Text>
                  Assistant Professor<br />
                  Harvey Mudd College<br />
                  Office: McGregor 330<br />
                  <tt>xanda@cs.hmc.edu</tt><br />
                  pronouns: she/her
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} md={6} lg={9}>
            <h2>Teaching (Fall 2023)</h2>
            <ul>
              <li><b>CS 123 - Computing Practices, Projects, and People</b> &#9679; <a href="https://harveymuddcollege.instructure.com/courses/614">Canvas</a></li>
            </ul>

            <h2>News</h2>
            <ul>
              <li><b>December 13, 2023</b>: Students Ford Ashmun and Stephanie Fulcar will be presenting their poster <a href="https://agu.confex.com/agu/fm23/meetingapp.cgi/Paper/1291350">Knowing Best: Distinguishing Features of Scientific Papers in Clean Air Policy</a> at AGU 2023! This is part of an ongoing collabotion with the <a href="https://www.ficus.space/">FICUS lab</a> led by Prof. Sarah Kavassalis. Congratulations as well to student co-contributors Jeremy Baaken, Anna Ding, and JP Walker.</li>
              <li><b>November 9-10, 2023</b>: Work from student Nile Phillips and Michelle Lum of the EconText lab was accepted as a poster to Text As Data 2023! Look forward to a poster link soon.</li>
              <li><b>October 20, 2022</b>: The <a href="https://www.bloomsbury.com/us/bloomsbury-handbook-to-the-digital-humanities-9781350232129/">Bloomsbury Handbook to the Digital Humanities</a> is here at last! It's an anthology of amazing perspective pieces on digital humanities as a discipline from a ``who's who'' in digital humanities. I'm honored to have been able to join with a chapter on natural language processing.</li>
              <li><b>October 14, 2022</b>: I  will be giving a talk as part of CMU's <a href="https://lti.cs.cmu.edu/lti-colloquium">LTI colloquium series</a>.</li>
              <li><b>June 27, 2022</b>: I was lucky enough to join the <a href="https://www.neh.gov/programinstitutefellowship/text-analysis-pedagogy-tap-institute">Text Analysis Pedagogy Institute</a> as an instructor for a three-lecture series on Text Data Curation. You can access IPython notebooks for the course <a href="">here</a>. </li>
            </ul>
            <br/>
            
          </Col>
        </Row>
        
      </div>
    );
  }
}

export default HomePage;
